import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedUseAltUsernamePassword = mutatorAction('updateAdvancedUseAltUsernamePassword', function (useAltUsernamePassword) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.useAltUsernamePassword = useAltUsernamePassword;
});
//# sourceMappingURL=updateAdvancedUseAltUsernamePassword.js.map